import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import Enrolment from "@/pages/Enrolment";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import WhatsAppButton from "@/components/site/WhatsAppButton";

const ScrollTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/join/:type" element={<Enrolment />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <WhatsAppButton />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
